<script> 
	import { onMount } from 'svelte';

	export let channel = 'site';

	onMount(async () => {
		newFlyBanner.mainURL = 'https://appsaopedroimoveis.com.br';
		newFlyBanner.singleView = false;
		newFlyBanner.load(channel);
	});
</script>